import { BaseLayout } from 'layout/base/main';
import './styles.scss';

export class WidgetLayout extends BaseLayout { }
